import {
  GET_SKU_MANAGEMENT_REQUEST,
  GET_SKU_MANAGEMENT_SUCCESS,
  GET_SKU_MANAGEMENT_FAILURE,
  GET_SKU_MANAGEMENT_WITHOUT_PAGINATION_FAILURE,
  GET_SKU_MANAGEMENT_WITHOUT_PAGINATION_REQUEST,
  GET_SKU_MANAGEMENT_WITHOUT_PAGINATION_SUCCESS,
  GET_SHIPMENT_REQUEST,
  GET_SHIPMENT_SUCCESS,
  GET_SHIPMENT_FAILURE,
  EDIT_SKU_REQUEST,
  EDIT_SKU_SUCCESS,
  EDIT_SKU_FAILURE,
  PRINT_SKU_REQUEST,
  PRINT_SKU_SUCCESS,
  PRINT_SKU_FAILURE,
  RELEASE_SHIPMENT_REQUEST,
  RELEASE_SHIPMENT_SUCCESS,
  RELEASE_SHIPMENT_FAILURE,
  CREATE_SKU_REQUEST,
  CREATE_SKU_SUCCESS,
  CREATE_SKU_FAILURE,
  GET_SKU_BY_ITEMID_REQUEST,
  GET_SKU_BY_ITEMID_SUCCESS,
  GET_SKU_BY_ITEMID_FAILURE,
  UPLOADCSV_FOR_SALES_ORDER_REQUEST,
  UPLOADCSV_FOR_SALES_ORDER_SUCCESS,
  UPLOADCSV_FOR_SALES_ORDER_FAILURE,
  GET_SKU_BY_SKUTYPE_REQUEST,
  GET_SKU_BY_SKUTYPE_SUCCESS,
  GET_SKU_BY_SKUTYPE_FAILURE,
  GET_MAPPED_SKU_REQUEST,
  GET_MAPPED_SKU_SUCCESS,
  GET_MAPPED_SKU_FAILURE,
  PRINT_SECONDARY_SKU_REQUEST,
  PRINT_SECONDARY_SKU_SUCCESS,
  PRINT_SECONDARY_SKU_FAILURE,
} from "./packagingWorkflowManagementTypes";
import axios from "axios";
import Config from "../../config/index";
let baseUrl = Config.baseUrl;

const getSkuManagementRequest = () => {
  return {
    type: GET_SKU_MANAGEMENT_REQUEST,
  };
};

const getSkuManagementSuccess = (payload) => {
  return {
    type: GET_SKU_MANAGEMENT_SUCCESS,
    payload: payload,
  };
};

const getSkuManagementFailure = (error) => {
  return {
    type: GET_SKU_MANAGEMENT_FAILURE,
    payload: error,
  };
};

const getSkuManagement = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getSkuManagementRequest());
    let url = `${baseUrl}/package/sku/get_all?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=0`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getSkuManagementSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getSkuManagementFailure(err.response));
      });
  };
};

const getSkuManagementWithoutPaginationRequest = () => {
  return {
    type: GET_SKU_MANAGEMENT_WITHOUT_PAGINATION_REQUEST,
  };
};

const getSkuManagementWithoutPaginationSuccess = (payload) => {
  return {
    type: GET_SKU_MANAGEMENT_WITHOUT_PAGINATION_SUCCESS,
    payload: payload,
  };
};

const getSkuManagementWithoutPaginationFailure = (error) => {
  return {
    type: GET_SKU_MANAGEMENT_WITHOUT_PAGINATION_FAILURE,
    payload: error,
  };
};

const getSkuManagementWithoutPagination = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getSkuManagementWithoutPaginationRequest());
    let url = `${baseUrl}/package/sku/get_all`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getSkuManagementWithoutPaginationSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getSkuManagementWithoutPaginationFailure(err.response));
      });
  };
};

const getShipmentRequest = () => {
  return {
    type: GET_SHIPMENT_REQUEST,
  };
};

const getShipmentSuccess = (payload) => {
  return {
    type: GET_SHIPMENT_SUCCESS,
    payload: payload,
  };
};

const getShipmentFailure = (error) => {
  return {
    type: GET_SHIPMENT_FAILURE,
    payload: error,
  };
};

const getShipment = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getShipmentRequest());
    let url = `${baseUrl}/package/sales_order/get_all?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=0`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getShipmentSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getShipmentFailure(err.response));
      });
  };
};

const createSkuRequest = () => {
  return {
    type: CREATE_SKU_REQUEST,
  };
};

const createSkuSuccess = (payload) => {
  return {
    type: CREATE_SKU_SUCCESS,
    payload: payload,
  };
};

const createSkuFailure = (error) => {
  return {
    type: CREATE_SKU_FAILURE,
    payload: error,
  };
};

const createSku = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createSkuRequest());
    let url = `${baseUrl}/package/sku/create`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createSkuSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createSkuFailure(err.response));
        return { status: false, message: err.response };
      });
  };
};

const editSkuRequest = () => {
  return {
    type: EDIT_SKU_REQUEST,
  };
};

const editSkuSuccess = (payload) => {
  return {
    type: EDIT_SKU_SUCCESS,
    payload: payload,
  };
};

const editSkuFailure = (error) => {
  return {
    type: EDIT_SKU_FAILURE,
    payload: error,
  };
};

const editSku = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(editSkuRequest());
    let url = `${baseUrl}/package/sku/update_qty`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(editSkuSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(editSkuFailure(err.response));
        return { status: false, message: err.response };
      });
  };
};

const printSkuRequest = () => {
  return {
    type: PRINT_SKU_REQUEST,
  };
};

const printSkuSuccess = (payload) => {
  return {
    type: PRINT_SKU_SUCCESS,
    payload: payload,
  };
};

const printSkuFailure = (error) => {
  return {
    type: PRINT_SKU_FAILURE,
    payload: error,
  };
};

const printSku = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(printSkuRequest());
    let url = `${baseUrl}/package/sku/primary/print`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(printSkuSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(printSkuFailure(err.response));
        return { status: false, message: err.response };
      });
  };
};

const printSecondarySkuRequest = () => {
  return {
    type: PRINT_SECONDARY_SKU_REQUEST,
  };
};

const printSecondarySkuSuccess = (payload) => {
  return {
    type: PRINT_SECONDARY_SKU_SUCCESS,
    payload: payload,
  };
};

const printSecondarySkuFailure = (error) => {
  return {
    type: PRINT_SECONDARY_SKU_FAILURE,
    payload: error,
  };
};

const printSecondarySku = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(printSecondarySkuRequest());
    let url = `${baseUrl}/package/sku/secondary/print`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(printSecondarySkuSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(printSecondarySkuFailure(err.response));
        return { status: false, message: err.response };
      });
  };
};

const releaseShipmentRequest = () => {
  return {
    type: RELEASE_SHIPMENT_REQUEST,
  };
};

const releaseShipmentSuccess = (payload) => {
  return {
    type: RELEASE_SHIPMENT_SUCCESS,
    payload: payload,
  };
};

const releaseShipmentFailure = (error) => {
  return {
    type: RELEASE_SHIPMENT_FAILURE,
    payload: error,
  };
};

const releaseShipment = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(releaseShipmentRequest());
    let url = `${baseUrl}/package/sales_order/release`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(releaseShipmentSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(releaseShipmentFailure(err.response));
        return { status: false, message: err.response };
      });
  };
};

const getSkuByItemIdRequest = () => {
  return {
    type: GET_SKU_BY_ITEMID_REQUEST,
  };
};

const getSkuByItemIdSuccess = (payload) => {
  return {
    type: GET_SKU_BY_ITEMID_SUCCESS,
    payload: payload,
  };
};

const getSkuByItemIdFailure = (error) => {
  return {
    type: GET_SKU_BY_ITEMID_FAILURE,
    payload: error,
  };
};

const getSkuByItemId = (itemId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getSkuByItemIdRequest());
    let url = `${baseUrl}/package/sku/get_sku_code_wrt_item?itemId=${itemId}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getSkuByItemIdSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getSkuByItemIdFailure(err.response));
      });
  };
};

const getSkuBySkuTypeRequest = () => {
  return {
    type: GET_SKU_BY_SKUTYPE_REQUEST,
  };
};

const getSkuBySkuTypeSuccess = (payload) => {
  return {
    type: GET_SKU_BY_SKUTYPE_SUCCESS,
    payload: payload,
  };
};

const getSkuBySkuTypeFailure = (error) => {
  return {
    type: GET_SKU_BY_SKUTYPE_FAILURE,
    payload: error,
  };
};

const getSkuBySkuType = (skuTypeId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getSkuBySkuTypeRequest());
    let url = `${baseUrl}/package/sku/get_by_type?skuTypeId=${skuTypeId}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getSkuBySkuTypeSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getSkuBySkuTypeFailure(err.response));
      });
  };
};

const uploadCsvForSalesOrderRequest = () => {
  return {
    type: UPLOADCSV_FOR_SALES_ORDER_REQUEST,
  };
};

const uploadCsvForSalesOrderSuccess = (payload) => {
  return {
    type: UPLOADCSV_FOR_SALES_ORDER_SUCCESS,
    payload: payload,
  };
};

const uploadCsvForSalesOrderFailure = (error) => {
  return {
    type: UPLOADCSV_FOR_SALES_ORDER_FAILURE,
    payload: error,
  };
};

const uploadCsvForSalesOrder = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(uploadCsvForSalesOrderRequest());
    let url = `${baseUrl}/package/sales_order/upload`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadCsvForSalesOrderSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadCsvForSalesOrderFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const getMappedSKURequest = () => {
  return {
    type: GET_MAPPED_SKU_REQUEST,
  };
};

const getMappedSKUSuccess = (payload) => {
  return {
    type: GET_MAPPED_SKU_SUCCESS,
    payload: payload,
  };
};

const getMappedSKUFailure = (error) => {
  return {
    type: GET_MAPPED_SKU_FAILURE,
    payload: error,
  };
};

const getMappedSKU = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getMappedSKURequest());
    let url = `${baseUrl}/package/sku_label/primary_secondary/get_all_mapped?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=0`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getMappedSKUSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getMappedSKUFailure(err.response));
      });
  };
};
export {
  getSkuManagement,
  getShipment,
  editSku,
  printSku,
  releaseShipment,
  getSkuManagementWithoutPagination,
  createSku,
  getSkuByItemId,
  uploadCsvForSalesOrder,
  getSkuBySkuType,
  getMappedSKU,
  printSecondarySku,
};
